function SoftwareActivationModalController() {
  const ctrl = this;
  ctrl.$onInit = () => {
    ctrl.packages = ctrl.resolve.packages;
    ctrl.train = ctrl.resolve.train;
    ctrl.carNumber = ctrl.resolve.carNumber;
    ctrl.activationMode = ctrl.resolve.mode;
    ctrl.sanctionedPackages = [];
    if (ctrl.activationMode === 'train') {

    } else {
      ctrl.filterValidPackages();
      if (ctrl.packagesCount > 1) {
        ctrl.multipleAvailable = true;
      } else {
        if (ctrl.filteredPackages.length > 0) {
          ctrl.multipleAvailable = false;
          ctrl.selectPackage(ctrl.filteredPackages[0]);
        }
        if (ctrl.sanctionedPackages.length > 0) {
          ctrl.multipleAvailable = false;
          ctrl.selectPackage(ctrl.sanctionedPackages[0]);
        }
      }
    }
  };

  ctrl.filterValidPackages = () => {
    ctrl.filteredPackages = ctrl.packages.filter(obj => {
      return obj.status === 'Engineering' || obj.status === 'Valid';
    });
    _.each(ctrl.packages, pkg => {
      if (pkg.status === 'Sanctioned') {
        ctrl.sanctionedPackages.push(pkg);
      }
    });
    ctrl.packagesCount = ctrl.filteredPackages.length + ctrl.sanctionedPackages.length;
  };

  ctrl.selectPackage = pkg => {
    ctrl.selectedPackage = pkg;
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('modalDirectives')
  .controller('SoftwareActivationModalController', SoftwareActivationModalController);
